import React from 'react';
import {EditorEvent} from '../events';
import {editorDefaultProps, EditorProps, editorPropTypes, mapDefaultProps, MapProps, mapPropTypes} from './props';
import connectFull from './connectFull';
import UnconnectedMapEditor from './UnconnectedMapEditor';

/**
 * Mapový editor (varianta s konfigurací mapy ve store).
 * Interní skrytá implementace.
 *
 * @ignore
 */
const ConnectedMapEditor = connectFull<EditorProps, EditorEvent>(UnconnectedMapEditor);

/**
 * Properties mapového editoru (varianta s konfigurací mapy ve store).
 */
export type MapEditorProps = MapProps<EditorEvent> & EditorProps;

/**
 * Mapový editor (varianta s konfigurací mapy ve store).
 *
 * @param props - Properties komponenty.
 * @returns Element.
 */
export default function MapEditor(props: MapEditorProps): JSX.Element {
    return <ConnectedMapEditor debugName="MapEditor" {...props} />;
}

/**
 * Typy properties.
 */
MapEditor.propTypes = {
    ...mapPropTypes,
    ...editorPropTypes,
};

/**
 * Výchozí hodnoty properties.
 */
MapEditor.defaultProps = {
    ...mapDefaultProps,
    ...editorDefaultProps,
};
